import { useQuery } from "@tanstack/react-query";
import { fetchStorefrontProducts } from "../api/products";

export const useStoreProducts = (identifier: string | undefined) => {
  return useQuery({
    queryKey: ["storefront-products", identifier],
    queryFn: () => {
      if (!identifier) {
        throw new Error("Missing storefront identifier.");
      }
      return fetchStorefrontProducts(identifier);
    },
    enabled: Boolean(identifier),
    staleTime: 30_000,
  });
};
